import type { WritableSignal } from '@angular/core';
import { InjectionToken, inject, signal } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import type { SetAntragResponse } from '@comparit/common-api';
import { KfzRoutes } from '../app.routes.paths';

export const SET_ORDER_DATA = new InjectionToken<WritableSignal<SetAntragResponse | null>>(
  'SetOrderData',
  {
    providedIn: 'root',
    factory: () => signal(null),
  }
);

export const setOrderResultsGuard: CanActivateFn = () => {
  const data = inject(SET_ORDER_DATA);
  if (data()) return true;
  return inject(Router).createUrlTree([KfzRoutes.step(1)]);
};
